import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import EmployeeLaporan from "@/pages/EmployeeLaporan";
import CompanyLaporan from "@/pages/CompanyLaporan";
import TeamLaporan from "@/pages/TeamLaporan";

export default function Performance() {
  const { isAdmin } = useAuth();
  if (!isAdmin) return <EmployeeLaporan />;
  return <Navigate to="/performance/company" replace />;
}

export function AdminLaporan({ view = "company" }) {
  return (
    <div className="mx-auto max-w-7xl space-y-6" data-testid="admin-laporan-page">
      {view === "team" ? <TeamLaporan /> : <CompanyLaporan />}
    </div>
  );
}
